const ua = window.navigator.userAgent

export default function isIE () {
    const msie = ua.indexOf('MSIE ')
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
    }

    const trident = ua.indexOf('Trident/')
    if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:')
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
    }

    // other browser
    return false
}

export function isEdge () {
    const edge = ua.indexOf('Edge/')
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
    }

    // other browser
    return false
}

export function isIE10 () {
    const ua = window.navigator.userAgent
    const msie = ua.indexOf('MSIE ')
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
    }
    // other browser
    return false
}

export function isSafari () {
    let match = navigator.userAgent.match(/Version\/[\d.]+.*Safari/)
    if (match) {
        match = match[0]
        return parseInt(match.substring(match.indexOf('Version/') + 8, match.indexOf(' ')), 10)
    }
    return false
}



// WEBPACK FOOTER //
// ./node_modules/nespresso-library/src/utils/userAgent.js